import env from "./env";
import axios from "axios";
import router from "../router";
import cookies from "vue-cookies";
/*
 * API_1 配置
 */
const API_1_CONF = {
  dev: "//180.76.151.47:7100", //192.168.2.198:7100
  development: "//180.76.151.47:7100", //dev
  test: "//192.168.3.136:7100", // 测试环境
  production: "//180.76.151.47:7100", // 线上环境//192.168.3.136:7100 //180.76.151.47:7100
};
export const API_1 = API_1_CONF[env];
export const user = "/user";
export const task = "/task";
export const msg = "/messages";
export const examination = "/examination";
export const Public = {
  getCode: user + "/public/code", //登录
  login: user + "/public/login_register", //验证码登录或注册
  passwordLogin: user + "/public/login_password", //密码登录
  getEnum: task + "/public/enum", //获取枚举表
  passwordChange1: user + "/public/user_password_code", //修改密码第一步
  passwordChange2: user + "/public/user_password", //修改密码第二步
  //招募
  getRecruitList: examination + "/public/recruitment_list",
  getChoiceList: examination + "/public/recruit_choice_list",
};
export const Adm = {
  //招募
  getRecruitDetail: examination + "/private/search_recruitment_detailed",
  submitRecruit: examination + "/private/register",
  //
  upload: user + "/private/kf_file", //上传文件
  editUserInfo: user + "/private/user_socialization", //修改用户社交信息
  getUser: user + "/private/user", //获取用户账号信息（安全中心）
  numberChange: user + "/private/user_phone_email_code", //修改手机或邮箱密码
  userAuthentication: user + "/private/user_document", // 用户身份验证
  getUserPayee: user + "/private/user_document_payee", // 用户实名和收款信息
  postUserPayee: user + "/private/user_payee", // 用户收款信息(后端不验证)
  getUserInfo: user + "/private/user_socialization", // 获取用户社交信息
  numberChange1: user + "/private/user_phone_email_code", //修改手机或邮箱第一步
  numberChange2: user + "/private/user_phone_email", //修改手机或邮箱第二步
  numberChange3: user + "/private/user_phone_email_set", //修改手机或邮箱第三步
  postBio: user + "/private/user_resume", // 创建/修改简历-个人中心
  getuserBio: user + "/private/user_resume", // 获取简历信息
  putuserBio: user + "/private/user_resume_type", // 提交认证
  postuser_certificate: user + "/private/user_certificate", // 新增/修改证书
  deluser_certificate: user + "/private/user_certificate", // 删除证书
  getuser_certificate: user + "/private/user_certificate", // 获取证书
  getSkill: user + "/private/user_skill", //获取用户标签
  getSchedule: user + "/private/user_level_condition", //查看升级进度 post方法是手动点升级
  getUserField: user + "/private/user_field", //个人领域
  uploadFileUrl: user + "/private/resume_file", //上传简历后给后端发地址

  //订单相关
  //getTaskList: task + "/private/task_list", //获取任务订单列表
  getTaskInfo: task + "/private/user_task", //获取任务订单详情
  //getTask: task + "/private/task", //抢单和提交译文 用请求方法区分开
  submitTask: task + "/private/putTask", //提交译文
  // getUserTask: task + "/private/user_task_list", //获取用户订单表

  // 试卷认证部分
  getUser_grade: user + "/private/user_grade", // 认证状态-等级及流程展示
  getGrade: user + "/private/grade", // 获取用户等级
  getk_condition: user + "/private/k_condition", // 获取升级条件
  getExam_rule: examination + "/private/exam_rule", // 获取试卷说明
  getExam_paper: examination + "/private/exam_paper", // 生成试卷id
  getUser_exam_paper: examination + "/private/user_exam_paper", // 试卷内容
  postUser_exam_paper: examination + "/private/user_exam_paper", // 提交试卷
  getUser_exam_paper_pass: examination + "/private/user_exam_paper_pass", // 通过的试卷信息
  getExam_rule_enum: examination + "/private/exam_rule_enum", // 可以测试的语言枚举
  putK_condition: user + "/private/k_condition", // 我要认证
  getGrade_application: user + "/private/grade_application", // 申请领域测试的进度
  getLingYu: user + "/private/exam_rule", // 领域测试的语向
  getExam_rule_field: examination + "/private/exam_rule_field", // 获取领域试卷说明
  getUser_exam_paper_file: examination + "/private/user_exam_paper_file", // 修改试卷绑定的证明文件

  //新做订单相关 上面旧的弃用
  // 抢单
  getTaskList: task + "/private/open_task_list", //获取待抢订单列表
  getTask: task + "/private/open_task", //抢单
  getOpen_task: task + "/private/open_task", // 订单详情
  uploadFile: task + "/private/open_task_file", //上传方案(时间点)文件
  getPlan: task + "/private/open_task_plan", //获取方案
  getPlanFile: task + "/private/open_task_plan_file", //获取方案中的文件
  getUserTask: task + "/private/user_open_task_list", //我的订单
  getPrice: task + "/private/open_task_cost", //获取译费
  putCourse: task + "/private/open_task_course", // 催一下/开始翻译
  putStart: task + "/private/open_task_start", // 开始翻译
  putFinish: task + "/private/open_task_finish", // 完成任务
  confirmPrice: task + "/private/open_task_cost", //确认译费
  getcost: task + "/private/open_task_cost", // 获取实际译费
  putcost: task + "/private/open_task_cost", // 确认译费
  gettask_log: task + "/private/open_task_log", // 获取项目日志
  checkPlan: task + "/private/open_task_change_content", //获取修改方案 然后对比
  handleCheckPlan: task + "/private/open_task_change", //确认或拒绝修改的方案
  puttask_abandon: task + "/private/open_task_abandon", // 译员放弃订单
  getReturn: task + "/private/open_task_trouble_list", //获取返稿和售后的列表
  getReturnDetail: task + "/private/open_task_trouble_file", //获取返稿或售后的详情
  completeSales: task + "/private/open_task_trouble", //完成售后
  getOpen_task_trouble_list: task + "/private/open_task_trouble_list", // 查看返稿/售后
  getOpen_task_trouble_file: task + "/private/open_task_trouble_file", // 查看返稿/售后 译员文件
  putOpen_task_trouble: task + "/private/open_task_trouble", // 返稿/售后 提交完成
  putOpen_task_trouble_file: task + "/private/open_task_trouble_file", // 上传返稿/售后稿件
  postActual_total_income: task + "/private/actual_total_income", // 钱包
  //消息接口
  getMessageList: msg + "/private/messages", //获取消息表  put 是变已读状态
  getMessageCount: msg + "/private/messages_count", //获取未读数量
  getIntegral: msg + "/private/integral", // 总分 积分明细
};
// 设置API的请求头
axios.defaults.baseURL = API_1;
// axios.defaults.withCredentials = true; // 允许携带凭证
/**
 * 拦截发送请求
 */
axios.interceptors.request.use(
  (config) => {
    if (config.url.indexOf("/kcms/") != -1) {
    } else {
      if (config.url.indexOf("/pubilc/") == -1) {
        config.headers["Authorization"] = cookies.get("token");
      }
    }

    return config;
  },
  (error) => {
    console.log(error);
    Promise.reject(error);
  },
);
/**
 * 拦截请求返回
 */
axios.interceptors.response.use(
  (response) => {
    let res = JSON.parse(JSON.stringify(response));
    let datas = res;
    switch (datas.status) {
      case "200":
        return response;
      case "401":
        router.push({ path: "/login" });
        $cookie.remove("uid");
        $cookie.remove("token");
        return response;
      case "404":
        return response;
        break;
    }
    return response;
  },
  (error) => {
    let err = JSON.parse(JSON.stringify(error));
    //  console.log(err.status);
    if (err.status == 401) {
      return Promise.reject(router.push({ path: "/login" }));
    }
    return Promise.reject(error);
  },
);
